import FitbitIcon from './Fitbit'
import FitbitArrowIcon from './FitbitArrow'

export default {
    FitbitIcon,
    FitbitArrowIcon
}
